import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppStore } from '../../store/useAppStore'

interface VehiclePhotoCurrentSideInfo {
  info: { sideKey: string; sideText: string }
  perviousTabValue: number
}

const useVehiclePhotoCurrentSideInfo = () => {
  const { t } = useTranslation()
  const tabValue = useAppStore((state) => state.tabValue)

  const vehiclePhotoCurrentSideInfoRef = useRef<VehiclePhotoCurrentSideInfo>({
    info: {
      sideKey: '',
      sideText: '',
    },
    perviousTabValue: 0,
  })
  // Run only when tab value is changed
  if (
    vehiclePhotoCurrentSideInfoRef.current.perviousTabValue !== tabValue ||
    tabValue === 0
  ) {
    let sideKey
    let sideText = t('vehicle.take_picture_of')
    switch (tabValue) {
      case 0:
        sideKey = 'inside'
        sideText += t('vehicle.inside')
        break
      case 1:
        sideKey = 'front'
        sideText += t('vehicle.front')
        break
      case 2:
        sideKey = 'left'
        sideText += t('vehicle.left')
        break
      case 3:
        sideKey = 'rear'
        sideText += t('vehicle.rear')
        break
      default:
        sideKey = 'right'
        sideText += t('vehicle.right')
        break
    }
    vehiclePhotoCurrentSideInfoRef.current.info = { sideKey, sideText }
    vehiclePhotoCurrentSideInfoRef.current.perviousTabValue = tabValue
  }

  return vehiclePhotoCurrentSideInfoRef.current.info
}

export default useVehiclePhotoCurrentSideInfo
